export const en = {
    choose_for: 'Choose for',
    chose_for: 'Chose for',
    tariff: 'Tariff',
    option: 'Option {number}',
};
